
function compareTableValue(a, b, type = "text") {
  if (type === "number") {
    return (Number(a || 0) - Number(b || 0));
  }
  if (type === "date") {
    return (new Date(a || 0).getTime() || 0) -
           (new Date(b || 0).getTime() || 0);
  }
  return String(a ?? "").localeCompare(String(b ?? ""), "id", {
    numeric: true, sensitivity: "base"
  });
}

function sortTableRows(rows, config) {
  const { key, direction, type = "text" } = config;
  const sign = direction === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => {
    const result = compareTableValue(a?.[key], b?.[key], type);
    return result === 0 ? 0 : result * sign;
  });
}

function SortHead({ label, field, config, onSort, type = "text", className = "" }) {
  const active = config.key === field;
  return (
    <button type="button" onClick={() => onSort(field, type)}
      className={`inline-flex items-center gap-1 font-semibold hover:text-orange-600 ${className}`}
      title={`Urutkan ${label}`}>
      {label}
      <span aria-hidden="true" className={active ? "text-orange-600" : "text-slate-400"}>
        {active ? (config.direction === "asc" ? "↑" : "↓") : "↕"}
      </span>
    </button>
  );
}

import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function AuditPage() {
  const [logs, setLogs] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "ts", direction: "desc", type: "date" });
  const toggleSort = (key, type = "text") => setSortConfig(prev => ({
    key,
    type,
    direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
  }));
  useEffect(() => { api.get("/audit-logs?limit=300").then(({data})=>setLogs(data)); }, []);

  return (
    <div className="page-shell">
      <div data-workspace-redundant-header><div>
        <h1 className="text-2xl font-extrabold font-display">Audit Log</h1></div>
        <p className="text-slate-500 text-sm">Aktivitas sensitif sistem · {logs.length} entri</p>
      </div>
      <Card>
        <CardHeader><CardTitle className="text-base">Riwayat Aktivitas</CardTitle></CardHeader>
        <CardContent>
          <Table>
            <TableHeader><TableRow>
              <TableHead><SortHead label="Waktu" field="ts" type="date" config={sortConfig} onSort={toggleSort} /></TableHead><TableHead><SortHead label="User" field="user_email" type="text" config={sortConfig} onSort={toggleSort} /></TableHead><TableHead><SortHead label="Role" field="user_role" type="text" config={sortConfig} onSort={toggleSort} /></TableHead>
              <TableHead><SortHead label="Action" field="action" type="text" config={sortConfig} onSort={toggleSort} /></TableHead><TableHead><SortHead label="Entity" field="entity" type="text" config={sortConfig} onSort={toggleSort} /></TableHead><TableHead><SortHead label="Detail" field="meta" type="text" config={sortConfig} onSort={toggleSort} /></TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {sortTableRows(logs, sortConfig).map(l => (
                <TableRow key={l.id}>
                  <TableCell className="text-xs font-mono">{new Date(l.ts).toLocaleString("id-ID")}</TableCell>
                  <TableCell className="text-sm">{l.user_email}</TableCell>
                  <TableCell><Badge variant="outline" className="text-[10px]">{l.user_role}</Badge></TableCell>
                  <TableCell><Badge className="bg-slate-700">{l.action}</Badge></TableCell>
                  <TableCell className="text-sm">{l.entity}</TableCell>
                  <TableCell className="text-xs text-slate-500 font-mono max-w-xs truncate">{JSON.stringify(l.meta)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
